import React from 'react';
import { Box, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type DossierFormaliteProcessesStatusProps = {
    label: string;
};

const DossierFormaliteProcessesStatus: React.FunctionComponent<DossierFormaliteProcessesStatusProps> =
    function (props) {
        const { label } = props;

        const expandSx = {
            display: 'flex',
            alignItems: 'center',
            gap: '0 4px',
        };

        const expandLabelSx = {
            fontWeight: '500',
            fontSize: '13px',
        };

        return (
            <Box sx={expandSx}>
                <FaOptionIcon
                    sx={{ lineHeight: 0, display: 'flex', alignItems: 'center' }}
                    icon={['fasl', 'file']}
                />
                <Typography sx={expandLabelSx}>{label}</Typography>
            </Box>
        );
    };

export default DossierFormaliteProcessesStatus;
